import { module } from 'modujs';
import * as focusTrap from 'focus-trap';
import barba from '@barba/core';

export default class extends module {
    constructor(m) {
        super(m);

        this.$select = this.$('select')[0]
        this.$content = this.$('content')[0]
        this.$toggler = this.$('toggler')[0]
        this.$togglerOpenLabel = this.$('toggler-open-label')[0]
        this.$togglerCloseLabel = this.$('toggler-close-label')[0]
        this.$currentCategoryName = this.$('currentCategoryName')[0]
        this.$currentCategoryQty = this.$('currentCategoryQty')[0]

        this.events = {
            click: {
                'toggler': 'toggle',
                'category-button': 'onCategoryClick'
            },
            change: {
                'select': 'onSelectChange'
            }
        }
    }

    init() {
        this.focusTrap = focusTrap.createFocusTrap(this.el, {
            onDeactivate: this.hide.bind(this),
            clickOutsideDeactivates: true
        });
    }

    toggle() {
        if(this.isOpened()) {
            this.hide();
        } else {
            this.show();
        }
    }

    isOpened() {
        return this.el.classList.contains('is-opened');
    }

    show() {
        this.el.classList.add('is-opened')
        this.$toggler.setAttribute('aria-expanded', 'true')
        this.$togglerOpenLabel.classList.add('-hidden')
        this.$togglerCloseLabel.classList.remove('-hidden')

        this.focusTrap.activate();
    }

    hide() {
        this.el.classList.remove('is-opened')
        this.$toggler.setAttribute('aria-expanded', 'false')
        this.$togglerOpenLabel.classList.remove('-hidden')
        this.$togglerCloseLabel.classList.add('-hidden')

        this.focusTrap.deactivate();
    }

    onSelectChange(e) {
        const dropdown = e.curTarget
        this.filterByEl(dropdown.options[dropdown.selectedIndex]);
    }

    onCategoryClick(e) {
        this.filterByEl(e.curTarget)
        this.hide()
    }

    filterByEl(el) {
        const data = JSON.parse(el.dataset.workFiltersData);

        this.$select.value = data.slug
        this.$currentCategoryName.innerText = data.name;
        this.$currentCategoryQty.innerText = (data.qty+'').padStart(2, '0');

        const href = window.location.pathname+'?category='+data.slug

        const trigger = document.createElement('a')
        trigger.href = href
        trigger.setAttribute('data-load-transition', 'work-list')

        barba.go(href, trigger);
    }

    destroy() {
        super.destroy()

        this.focusTrap.deactivate();
    }
}
